// NPM Requirements
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import MapMarkerHover from './MapMarkerHover';

import styles from './MapMarker.module.postcss';

class MapMarker extends PureComponent {
  constructor(props, _railsContext) {
    super(props);
    this.onClose = this.onClose.bind(this);
    this.state = {
      highlighted: false,
      showPopup: false,
      hover: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onClose(e) {
    e.stopPropagation();
    this.props.onClose();
  }

  render() {
    const { show, location, $geoService, $getDimensions, $dimensionKey } = this.props;
    const mapWidth = $geoService.getWidth()
    const x = $getDimensions($dimensionKey).x;

    let hoverSide = 'left';
    if (x < mapWidth / 2) {
      hoverSide = 'right';
    }

    const style = {
      zIndex: show ? 1000 : 1
    };

    return (
      <div
        className={cn({
          [styles.MapMarker]: true,
          [styles.MapMarker__highlighted]: show
        })}
        style={style}
      >

        <img className={styles.MapMarker_shadow} src="/static/images/map-marker-shadow.png" alt="" />

        <svg
          className={cn({
            [styles.MapMarker_pin]: true,
            [styles.MapMarker_pin__hover]: this.state.hover,
          })}
          fill="none"
          height="31"
          viewBox="0 0 23 31"
          width="23"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={styles.fill}
            clipRule="evenodd"
            d="M11.2971 30.1256C11.2971 30.1256 22.5942 17.5363 22.5942 11.2971C22.5942 5.05789 17.5363 0 11.2971 0C5.05789 0 0 5.05789 0 11.2971C0 17.5363 11.2971 30.1256 11.2971 30.1256Z"
            fillRule="evenodd"
            fill="#213F61"
          />
          <path
            clipRule="evenodd"
            d="M11.6109 14.4352C14.2106 14.4352 16.318 12.3277 16.318 9.72806C16.318 7.12839 14.2106 5.02094 11.6109 5.02094C9.01123 5.02094 6.90378 7.12839 6.90378 9.72806C6.90378 12.3277 9.01123 14.4352 11.6109 14.4352Z"
            fillRule="evenodd"
            fill="white"
          />
        </svg>

        { show &&
          <MapMarkerHover
            hoverSide={hoverSide}
            location={location}
            onClose={this.onClose}
          />
        }
      </div>
    );
  }
}

MapMarker.propTypes = {
  location: PropTypes.object,
  $hover: PropTypes.bool,
  $geoService: PropTypes.object,
  $getDimensions: PropTypes.func,
  $dimensionKey: PropTypes.string,
  onMouseEnter: PropTypes.func,
  history: PropTypes.object,
  onMouseLeave: PropTypes.func
};

export default MapMarker;
